/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';


class IspSupportSummary extends Component {

    render() {
        if (this.props.isp.supportUrl || this.props.isp.supportPhone || this.props.isp.supportFacebookUrl || this.props.isp.supportTwitterUrl) {
            const name = `${this.props.isp.name || ''}`;
            return (
                <div>
                    <h4 className="font-size-1 font-weight-normal text-secondary">Contact {name} support</h4>

                    <ul className="list-inline mb-0">
                        {
                            this.props.isp.supportFacebookUrl &&
                            <li className="list-inline-item mb-3">
                                <a className="btn btn-sm btn-icon btn-soft-primary rounded-circle"
                                   href={this.props.isp.supportFacebookUrl}
                                   rel="noopener noreferrer"
                                   target="_blank"
                                >
                                    <span className="fab fa-facebook-f btn-icon__inner"/>
                                </a>
                            </li>
                        }
                        {
                            this.props.isp.supportTwitterUrl &&
                            <li className="list-inline-item mb-3">
                                <a className="btn btn-sm btn-icon btn-soft-primary rounded-circle"
                                   href={this.props.isp.supportTwitterUrl}
                                   rel="noopener noreferrer"
                                   target="_blank"
                                >
                                    <svg 
                                        className="x-twitter"
                                        xmlns="http://www.w3.org/2000/svg" 
                                        height="16px" 
                                        width="16px"
                                        viewBox="0 0 512 512">
                                        <path fill="#8c98a4" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                                    </svg>
                                </a>
                            </li>
                        }
                        {
                            this.props.isp.supportUrl &&
                            <li className="list-inline-item mb-3">
                                <a className="btn btn-sm btn-icon btn-soft-primary rounded-circle"
                                   href={this.props.isp.supportUrl}
                                   rel="noopener noreferrer"
                                   target="_blank"
                                >
                                    <span className="fa fa-globe btn-icon__inner"/>
                                </a>
                            </li>
                        }
                        {
                            this.props.isp.supportPhone &&
                            <li className="list-inline-item mb-3">
                                <a className="btn btn-sm btn-icon btn-soft-primary rounded-circle" href={'tel:' + this.props.isp.supportPhone}>
                                    <span className="fa fa-phone btn-icon__inner"/>
                                </a>
                            </li>
                        }
                    </ul>
                </div>
            )
        } else {
            return '';
        }
    }
}

export default IspSupportSummary;